import { sendTriggerUpsellEvent } from '../shared/events';
import './expiredBanner.scss';

class _Controller {

  constructor(UserService, $window) {
    this.user = UserService.user;
    this.$window = $window;
    this.shown = !!this.user.isExpiredUser;
    this.text = this.user?.subscription?.state === 'incomplete' ? 'Your subscription requires payment.' : 'Your subscription has expired.';
    this.cta = this.user?.subscription?.state === 'incomplete' ? 'View payment details.' : 'Subscribe to keep searching.';
  }

  upgrade(e) {
    e.preventDefault();
    this.$window.location.href = `${__ZUUL_URL}/account/subscription`
    // sendTriggerUpsellEvent();
  }

}

_Controller.$inject = ['UserService', '$window'];

export const expiredBanner = {
  controller: _Controller,
  template: `
    <div ng-if='$ctrl.shown' id="expired-banner">
      <p>{{$ctrl.text}} <a ng-click='$ctrl.upgrade($event)'>{{$ctrl.cta}}</p>
    </div>`
}